import { RouteRecordRaw } from 'vue-router';

import { MERCHANT_SETTINGS_CHILDREN, USER_SETTINGS_CHILDREN } from '@/_redesign/modules/Profile/routes';
import { ROLES } from '@/constants/roles';
import BaseLayout from '@/layouts/base-layout.vue';
import { useUserDataStore } from '@/stores/UserData';

const DashboardMain = () => import(
  '@/_redesign/modules/UserDashboard/pages/DashboardMain.vue'
);

const AccountCoin = () => import('@/_redesign/modules/UserDashboard/pages/AccountCoin.vue');
const TransactionsList = () => import('@/_redesign/modules/UserDashboard/pages/TransactionsList.vue');

const AccountCard = () => import('@/_redesign/modules/UserDashboard/pages/AccountCard.vue');
const CardGrid = () => import('@/_redesign/modules/UserDashboard/pages/CardGrid.vue');

const ProfileSettingsLayout = () => import('@/_redesign/modules/Profile/layout/ProfileSettingsLayout.vue');

export const MERCHANT_DASHBOARD_CHILDREN: RouteRecordRaw[] = [
  {
    path: 'main',
    name: 'merchant-dashboard-main',
    component: DashboardMain,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
      },
    },
  },
  {
    path: 'transactions',
    name: 'merchant-dashboard-transactions',
    component: TransactionsList,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
      },
    },
  },
  {
    path: 'cards',
    name: 'merchant-dashboard-cards',
    component: CardGrid,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
      },
    },
  },
  {
    path: 'account/:serial',
    name: 'merchant-dashboard-account',
    component: AccountCoin,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
      },
    },
  },
  {
    path: 'cards/:serial',
    name: 'merchant-dashboard-account-card',
    component: AccountCard,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
      },
    },
  },
  {
    path: 'settings',
    name: 'merchant-dashboard-settings',
    component: ProfileSettingsLayout,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isBackVisible: true,
          backName: 'merchant-dashboard-main',
        },
      },
    },
    children: MERCHANT_SETTINGS_CHILDREN,
    redirect: MERCHANT_SETTINGS_CHILDREN[0],
  },
];

export const USER_DASHBOARD_CHILDREN: RouteRecordRaw[] = [
  {
    path: 'main',
    name: 'user-dashboard-main',
    component: DashboardMain,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
      },
    },
  },
  {
    path: 'transactions',
    name: 'user-dashboard-transactions',
    component: TransactionsList,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
      },
    },
  },
  {
    path: 'cards',
    name: 'user-dashboard-cards',
    component: CardGrid,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
      },
    },
  },
  {
    path: 'account/:serial',
    name: 'user-dashboard-account',
    component: AccountCoin,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
      },
    },
  },
  {
    path: 'cards/:serial',
    name: 'user-dashboard-account-card',
    component: AccountCard,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
      },
    },
  },
  {
    path: 'settings',
    name: 'user-dashboard-settings',
    component: ProfileSettingsLayout,
    meta: {
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isBackVisible: true,
          backName: 'user-dashboard-main',
        },
      },
    },
    redirect: USER_SETTINGS_CHILDREN[0],
    children: USER_SETTINGS_CHILDREN,
  },
];

export const MERCHANT_DASHBOARD: RouteRecordRaw = {
  path: '/merchant-dashboard',
  name: 'merchant-dashboard',
  component: BaseLayout,
  props: {
    baseLayoutConfig: {
      componentName: 'MerchantDashboardLayout',
    },
  },
  meta: {
    permission: [ROLES.merchant],
  },
  redirect: MERCHANT_DASHBOARD_CHILDREN[0],
  children: MERCHANT_DASHBOARD_CHILDREN,
};

export const USER_DASHBOARD: RouteRecordRaw = {
  path: '/user-dashboard',
  name: 'user-dashboard',
  component: BaseLayout,
  props: {
    baseLayoutConfig: {
      componentName: 'MerchantDashboardLayout',
    },
  },
  meta: {
    permission: [ROLES.individual, ROLES.sole_trader],
  },
  redirect: USER_DASHBOARD_CHILDREN[0],
  children: USER_DASHBOARD_CHILDREN,
};

export const UNIVERSAL_DASHBOARD: RouteRecordRaw = {
  path: '/universal-dashboard',
  name: 'universal-dashboard',
  meta: {
    permission: [ROLES.merchant, ROLES.individual, ROLES.sole_trader],
  },
  redirect: () => {
    if (useUserDataStore().role === ROLES.merchant) return MERCHANT_DASHBOARD;
    return USER_DASHBOARD;
  },
};
